export const MANUFACTURERS_REFRESH_FIRMWARE_OPEN_MODAL = "MANUFACTURERS_REFRESH_FIRMWARE_OPEN_MODAL";
export const MANUFACTURERS_REFRESH_FIRMWARE_REQUEST = "MANUFACTURERS_REFRESH_FIRMWARE_REQUEST";
export const MANUFACTURERS_REFRESH_FIRMWARE_RESULT = "MANUFACTURERS_REFRESH_FIRMWARE_RESULT";